<template>
  <Modal
    :id="'cmp-distribution-account_sidewindow-add_label'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t('add_label') }}</template>

    <template slot="body">
      <SearchList
        :id="'labelAccounts'"
        ref="searchList"
        :items="labelAccounts"
        :keyProperty="'label_id'"
        :label="'label_name'"
        :selectionNumber="'single'"
        @selected="onRowClicked"
        @searched="searchLabel"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onSave">
        {{ $dft.snakeCaseToWords("add_new_label") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { AccountService } from "../../services/account.service";
import SearchList from "@dtplugins/search-list/search-list";
export default {
  components: {
    SearchList,
    Modal,
  },

  data: function () {
    return {
      labelAccounts: [],
    };
  },
  props: ["selectedAccountsDetails"],
  mounted: function () {
    AccountService.getLabelAccount({
      account_id: this.selectedAccountsDetails.account.account_id,
    }).then((label) => {
      this.labelAccounts = label.data.unrelated_labels.filter(
        (l) => l.label_name != ""
      );
    });
  },
  computed: {},
  methods: {
    searchLabel: function (searchString) {
      AccountService.findLabelAccount({
        account_id: this.selectedAccountsDetails.account.account_id,
        label_name: searchString,
      }).then((label) => {
        this.labelAccounts = label.data.unrelated_labels.filter(
          (l) => l.label_name != ""
        );
      });
    },
    onSave: async function () {
      const data = await AccountService.addNewLabelAccount({
        account_id: this.selectedAccountsDetails.account.account_id,
        label_name: "",
      });
      this.$emit("added", [...data.data.label_accounts]);
    },
    onRowClicked: async function (label) {
      const label_ids = Array.from(label).join(",");
      if (label_ids && label_ids.length > 0) {
        const data = await AccountService.insertLabelAccount({
          account_id: this.selectedAccountsDetails.account.account_id,
          label_id: label_ids,
        });
        this.$emit("added", [...data.data.label_accounts]);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-distribution-account_sidewindow-add_label {
}
</style>
